import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import '../Subscription/../header/style.css';
import { Header } from "../Subscription";
import { AdminNavbar } from "../Subscription";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function EditSubscription() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [planTitle, setPlanTitle] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [status, setStatus] = useState("");

    useEffect(() => {
        fetchSubscriptionData();
    }, [id]);

    const fetchSubscriptionData = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/getSubscriptionPlanById/${id}`, {
            headers: {
              "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
              "Content-Type": "application/json",
            },
          });
      
          console.log("Fetched subscription data:", response.data);
      
          const data = Array.isArray(response.data) ? response.data[0] : response.data;
      
          if (data) {
            setTitle(data.title || "");
            setPlanTitle(data.plan_title || "");
            setDescription(data.description || "");
            setPrice(data.price || "");
            setStatus(data.status || "");
          } else {
            console.warn("No data found for the given subscription ID.");
          }
      
        } catch (err) {
          console.error("Error fetching subscription data:", err);
        }
      };
      

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("title", title);
        formData.append("plan_title", planTitle);
        formData.append("description", description);
        formData.append("price", price);
        formData.append("status", status);

        try {
            const response = await axios.post(`${API_BASE_URL}/createSubscriptionPlan/${id}`, formData, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) {
                navigate("/admin/SubscriptionList");
            } else {
                console.error("Unexpected response:", response.status);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Edit Subscription Plan</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Plan Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={planTitle}
                                            onChange={(e) => setPlanTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Price</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={description}
                                            onChange={setDescription}
                                            style={{ height: '200px', marginBottom: '50px' }}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-primary submit-btn">
                                        UPDATE
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditSubscription;
